import React, {useState, useEffect} from 'react'
import ProductCategory from '../components/PorductCategory'
import ProductS from '../components/ProductS'
import { useAappContext } from '../context/AppContext'
import ProductGroup from '../components/ProductGroup'
import { useLocation } from 'react-router-dom';
import loading from '../assest/loading/Settings.gif'

const ProductsAll = () => {
    const{ isLoading, products} = useAappContext();

    const query = new URLSearchParams(useLocation().search).get('query') || '';
      const results = products.filter(p =>
        p.name.toLowerCase().includes(query.toLowerCase())
      );


    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;
    
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    
    const currentProducts = results.slice(indexOfFirstProduct, indexOfLastProduct);
    const totalPages = Math.ceil(results.length / productsPerPage);







    const [Fixing, setFixingNavbar] = useState(false)
    useEffect(() => {
      
       window.addEventListener('scroll',()=>{
        var scroll_position = window.scrollY;
        if(scroll_position >450){
         setFixingNavbar(!Fixing)
        }else{
          setFixingNavbar(false)  
        }
         })
    },[])

    if (isLoading){
      return <div style={{
                  
                  display:'flex',
                  justifyContent:"center",
                  alignItems:"center",
                  fontSize:18,
                  color:"green",
                  
                }}> <img src={loading} alt="" /></div>
    }
    
    
    return ( 

        <>
        <ProductCategory />
        <section id="productsSection" className="section-p1 section-m1">

        <div id="page-title" className='title-red' style={{marginLeft:0}}>
          <span>All Producas</span>
        </div>
            <br/>
            <div className="container">
            {/* <div className={`${Fixing ? 'fix':'hide'} main-produc-group-container`}> */}
           
            <div className='main-produc-group-container'>
              <div className="main-produc-group-header">
                    <h3>main product group </h3>
              </div>
                
                <ProductGroup/>
            </div>

              {/* <div className= {`${Fixing ? 'productContaner ml':'productContaner'} `}> */}
              <div className='productContaner'>
              {
                  currentProducts.map((curElem)=>{
                      return <ProductS key={curElem.id} {...curElem} />
                  })
                }
            </div>
            </div>
            <div className="pagination-controls">
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => {
                window.scrollTo(0, 500);
                setCurrentPage(index + 1)
              }}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
            </section>  
        </>
  )
}

export default ProductsAll

// export default Product;